module.exports = __webpack_public_path__ + "media/post-listing-block-3-image.ba1511e4.jpg";